<template>
    <div class="cookies-banner" v-if="show">
        <div class="container">
            <div class="content">
                <div class="text">
                    <h1>Bem-vindo!</h1>
                    <p>
                        Este site utiliza cookies para melhorar a sua experiência de navegação, analisar o desempenho do site e 
                        ajudar nos nossos esforços de marketing. Ao continuar a navegação você concorda com o uso de cookies, com 
                        nossa <a :href="urlMeusPedidos + '/politica-privacidade'" target="_blank">Política de Privacidade</a> e com os nossos 
                        <a :href="urlMeusPedidos + '/termos-e-condicoes-de-uso'" target="_blank">Termos e Condições de Uso.</a>
                    </p>
                </div>
                <div class="links">
                    <a href="#" v-on:click="showModal">Configurar Preferências</a>
                    <button class="cookies-accept" v-on:click="accept">Aceito todos os cookies</button>
                </div>
            </div>
        </div>        
    </div>    
</template>

<script>
    export default {
        name: "c-cp-cookies-banner",
        props: ['acceptCookies'],
        data() {
            return {
                show: true,
                urlMeusPedidos: MEUS_PEDIDOS_URL
            }
        },
        methods: {    
            showModal(e) {
                e.preventDefault();
                
                this.$store.dispatch('modalCookiesPreferences/showModal');
            },        
            async accept() {   
                const cookies = { 
                    'accept_cookies': 1,
                    'advertising_cookies': 1,
                    'features_cookies': 1,
                    'necessary_cookies': 1,
                    'performance_cookies': 1
                };

                try {
                    await this.axios.post(API_URL + '/cookies/aceitar-cookies', cookies)

                    document.location.reload()

                    return false
                } catch (error) {
                    console.log(error)
                }                            
            },
        },    
        mounted() {                     
            if (this.acceptCookies == 1) {
                this.show = false
            } 
        },
    }
</script>
